import { Component, Input } from "@angular/core";
import { CONTENT_BOX_ANIMATIONS } from "../../../shared/animations/content-box-animations";

@Component({
    selector: "app-image-animation",
    templateUrl: "./image-animation.component.html",
    styleUrls: ["./image-animation.component.scss"],
    animations: CONTENT_BOX_ANIMATIONS,
    standalone: false
})
export class ImageAnimationComponent {
  @Input() animationState = false;
  @Input() animationType;
  @Input() animationDirection;

}
